const parishSettingsData = [
  {
    name: "Bethany Hills",
    collection: 5355,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Purakkayam",
    collection: 6540,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Vadakkemala",
    collection: 8160,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Cheenkalthadam",
    collection: 8900,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Nallathanny",
    collection: 10320,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Nirmalapuram",
    collection: 10845,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Uluppooni",
    collection: 11850,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Arayanjilimannu",
    collection: 12600,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Perumthenaruvi",
    collection: 13170,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Mukkulam",
    collection: 13310,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Azhangad",
    collection: 14660.28,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Mettukuzhi",
    collection: 15020,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Chottupara",
    collection: 16250,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Koothattukulam",
    collection: 16250,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Yendayar",
    collection: 16370,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Sanyasiyoda",
    collection: 17620,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Christunagar ",
    collection: 18090,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Perunad",
    collection: 18350,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Mangappara",
    collection: 18470,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Grace Valley",
    collection: 18500,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Aniyartholu",
    collection: 20270,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Poomattam",
    collection: 20400,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Pampadumpara",
    collection: 21875,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Meloram",
    collection: 22610,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Mulamkunnu",
    collection: 23330,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Meppara",
    collection: 24640,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Meenkuzhy",
    collection: 24700,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Padanilam ",
    collection: 26620,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Santhigiri",
    collection: 27790,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Elivalikkara",
    collection: 28000,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Chempanoly",
    collection: 29200,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Vallakkadavu",
    collection: 29300,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Edamon",
    collection: 29600,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Greenvalley ",
    collection: 30150,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Pullikkanam",
    collection: 30500,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Seethathodu",
    collection: 31575,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Umikkuppa",
    collection: 32060.28,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Eruthuapuzha",
    collection: 32695,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Alampally",
    collection: 34715,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Pezhumpara",
    collection: 35235,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Niravu",
    collection: 36000,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Mariagiri",
    collection: 36780,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Amalagiri",
    collection: 38200,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Panapilavu",
    collection: 38620,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Pulinkatta",
    collection: 38635.28,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Konni",
    collection: 40400,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Grace Mount",
    collection: 40500,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Cheruvallikulam",
    collection: 42620,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Angelvalley",
    collection: 43080,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Placherry",
    collection: 44850,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Swaraj",
    collection: 47840,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Chennakkunnu",
    collection: 50101,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Thekkemala",
    collection: 50320,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Nariampara",
    collection: 50450,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Kochera",
    collection: 50600,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Kanayankavayal",
    collection: 50635,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Chinnar",
    collection: 51785,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Nirmalagiri",
    collection: 53000,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Pazhaya Koratty",
    collection: 54460,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Vanchimala",
    collection: 54840,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Elappara",
    collection: 56845.28,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Periyar Vallakadavu",
    collection: 57210,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Karunapuram",
    collection: 58165,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Edakkunnam",
    collection: 58410,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Keerikara",
    collection: 59650,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Madukka",
    collection: 60000,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Palapra",
    collection: 60230,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Karikkattoor",
    collection: 61840,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Rajagiri",
    collection: 61925,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Kurumpanmuzhy",
    collection: 62960,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Pullanithakidy",
    collection: 63950,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Ranni",
    collection: 65400,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Chemmannu",
    collection: 66495,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Third Camp",
    collection: 67430,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Kannampally",
    collection: 67850,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Kochuthovala",
    collection: 71580,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Thulappally",
    collection: 72830,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Kuttikkanam",
    collection: 73350,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Mlamala",
    collection: 76070,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Paloorkkavu",
    collection: 76090,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Tharakanattukunnu",
    collection: 78665,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Peruvanthanam",
    collection: 79340,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Chakkupallam",
    collection: 80490,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Kalthotty",
    collection: 83015,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Palampra",
    collection: 84690,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Thachapuzha",
    collection: 85600,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Neyyattuserry",
    collection: 87465,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Vellaramkunnu",
    collection: 87835,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Inchiyany",
    collection: 90405,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Pathanamthitta",
    collection: 92450,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Mundiyeruma",
    collection: 94920,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Elangoi",
    collection: 95905,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Ramakkalmedu",
    collection: 98979,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Punchavayal",
    collection: 101785.84,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Amaravathy",
    collection: 104880,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "John Paul Nagar",
    collection: 105530,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Pazhayidom",
    collection: 106405,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Manipuzha",
    collection: 109330,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Mukkoottuthara",
    collection: 110940,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Cheruvally",
    collection: 111010,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Anavilasam",
    collection: 112340,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Karikulam",
    collection: 112510,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Chamampathal",
    collection: 118555.84,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Peermade",
    collection: 120000,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Valiyathovala",
    collection: 129410,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Thampalackadu",
    collection: 130630,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Kannimala",
    collection: 133510,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Pulianmala",
    collection: 135015.03,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Chembalam",
    collection: 137860,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Kuzhitholu",
    collection: 138215,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Chellarcoil",
    collection: 148611.84,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Wallardie",
    collection: 154400,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Koruthodu",
    collection: 156650,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "KorattyPuthenpalli",
    collection: 156860,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Kanchiyar",
    collection: 162410,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Elikkulam",
    collection: 176285,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Upputhara ",
    collection: 181325,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Vandanpathal",
    collection: 183270,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Nettithozhu",
    collection: 183810,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Puttady",
    collection: 200000,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Anchilippa",
    collection: 217800,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Nazranipuram",
    collection: 220846,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Erumely",
    collection: 244250,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Chengalam",
    collection: 258650,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Vechoochira",
    collection: 258960,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Mundakayam",
    collection: 278500,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Marykulam",
    collection: 283159,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Kollamula",
    collection: 314360,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Chenkal",
    collection: 366320,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Anakkara",
    collection: 375000,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Thamarakunnu",
    collection: 401610,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Kumily",
    collection: 402330,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Kappadu",
    collection: 448195,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Koovappally",
    collection: 461815,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Kunnumbhagam",
    collection: 473300,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Ponkunnam",
    collection: 527480,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Anickadu",
    collection: 558730,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Velichiyani",
    collection: 624500,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Kattappana",
    collection: 680000,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Podimattam",
    collection: 726325,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Elamgulam",
    collection: 939960,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Kanjirapally",
    collection: 1607771,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Cumbummettu",
    collection: 0,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Mangapetta",
    collection: 0,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Kozhancherry",
    collection: 0,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
  {
    name: "Vakayar",
    collection: 0,
    prelim: 0,
    prop: 0,
    total: 0,
    pre_prop: 0,
  },
];

export default parishSettingsData;
